import React, { useState, useRef, useEffect, forwardRef } from 'react';
import { Switch, Empty, Table, Button, Col, Tag, Drawer, Form, Input, Row, Select, Space, message, Modal, Typography, InputNumber } from 'antd';
import {getAll as getConceptos} from '../../apis/ConceptoApi';
import _ from 'lodash';

const { Option } = Select;
const Conceptos = forwardRef(function Conceptos(props, ref) {
    const {form} = props;
    const [conceptos, setConceptos] = useState([]);
    const [concepto, setConcepto] = useState(null);
    const effectRan = useRef(false);

    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                await getCatalogs();
            })();
        }
        return () => effectRan.current = true;
    }, []);

    useEffect(() => {
        (async () => {
            if(conceptos?.length > 0){
                await changeConcepto(form.getFieldValue("concepto"));                    
            }
        })();
    }, [conceptos]);
 
    const getCatalogs = async ()=> {
        const responseConcepts = await getConceptos();
        if(responseConcepts.ok){
          let items = responseConcepts.payload;
          setConceptos(items);
        }
    }

    const changeConcepto = async (value) => {
        var _concepto = conceptos.find(x=>x.id == value)
        if(!_concepto){return;}
        setConcepto(_concepto);
        var values = form.getFieldsValue();
        form.setFieldsValue({
            ...values,
            concepto_id: _concepto.id,
            clave_concepto: _concepto.clave
        });
    }


    return <Select placeholder="Por favor selecciona un concepto" onChange={changeConcepto}>
        {
            conceptos.map((item)=><Option value={item.id}>{item.displayTitle}</Option>)
        }
    </Select>;
});
export default Conceptos;